import { Component } from "@angular/core";
import { InlineMessageComponent } from "@odx/angular/components/inline-message";

@Component({
  selector: "app-mobile-floorplans-warning",
  imports: [InlineMessageComponent],
  templateUrl: "./mobile-floorplans-warning.component.html",
  styleUrl: "./mobile-floorplans-warning.component.scss",
})
export class MobileFloorplansWarningComponent {}
